var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M5.738 4.667c2.348-2.223 6.176-2.223 8.524 0 2.317 2.194 2.317 5.727 0 7.92L10 16.624l-4.262-4.036c-2.317-2.193-2.317-5.726 0-7.92m9.9-1.452c-3.12-2.953-8.156-2.953-11.275 0-3.15 2.983-3.15 7.842 0 10.825l4.95 4.686h1.374l4.95-4.686c3.15-2.983 3.15-7.842 0-10.825M10 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
export default SvgLocation;